import Controller from "./cityFeatureFlags.controller";
import template from "./cityFeatureFlags.html";

const cityFeatureFlags = {
  template,
  controller: Controller,
  bindings: {
    cityId: "<",
    categoriesFlag: "<",
    travelSuggestionsFlag: "<",
  },
};

export default cityFeatureFlags;



// WEBPACK FOOTER //
// ./src/components/cityFeatureFlags/cityFeatureFlags.component.js